export const Currencies = [
    { id: 208, code: 'DKK' },
    { id: 978, code: 'EUR' },
    { id: 578, code: 'NOK' },
    { id: 752, code: 'SEK' },
    { id: 840, code: 'USD' }
];